<script>
    const cookieName = 'show_deleted_account_lightbox';
    export default {
                props: ['user','deleteAccountUrl'],

        mounted: function(){
            $(this.$refs.termsDeleteModal).on("hidden.bs.modal", this.switch);
        },

        methods: {
            switch: function(event){
               $( "#terms_switch" ).prop( "checked", true );
            },
            onDelete: function(event){
                this.$http.post(
                    this.deleteAccountUrl,
                    {
                        user: this.user
                    },
                    {   headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then((response) => {
                    if(response.status==204){
                        this.$cookies.set(cookieName, '1', null, null, locations.cookie_domain);
                        window.location.replace('https://'+window.location.hostname);
                    }
                    return;
                }).catch((error)=>{
                    console.error(error);
                });
            }
        }
    };
</script>

